import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { sendTwoFactor } from 'services/auth'
import { useAuth } from '../../../../context/authContext'
import posthog from 'posthog-js'

interface ISendTwoFactorPayload {
    phone_number: string
    password: string
    two_factor_token: string
}
const UseSendTwoFactor = () => {
    const navigate = useNavigate()
    const { login } = useAuth()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISendTwoFactorPayload) => {
            return sendTwoFactor(payload)
        },
        onSuccess: (data) => {
            toast.success('ورود با موفقیت انجام شد')
            posthog.capture('two_factor_signin');

            login(data)
            navigate('/auth/profile')
        },
        onError: () => {
            toast.error('خطایی رخ داده!')
        },
    })

    return { isLoading, mutate }
}

export default UseSendTwoFactor
